<template>
  <el-table-column
    prop="user_name"
    sortable="custom"
    label="Képviselő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.representative_user_id && scope.row.representative_user">
        <strong>#{{ scope.row.representative_user_id }}</strong> {{ scope.row.representative_user.full_name }}
      </div>
      <div v-else>
        <div>{{ scope.row.user_name }}</div>
        <el-tag
          size="mini"
          type="danger"
        >
          Törölt felhasználó
        </el-tag>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'user_name',
  };
</script>
